"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var Cookie = function () {
  function n() {}

  return n.setCookie = function (e, t) {
    var o = new Date(),
        i = t;
    o.setTime(o.getTime() + 365 * n.day), document.cookie = e + "=" + i + "; expires=" + o.toUTCString() + "; path=/";
  }, n.getCookie = function (e, t) {
    var o = ("; " + document.cookie).split("; " + e + "=");
    return 2 === o.length ? o.pop().split(";").shift() : t;
  }, n.deleteCookie = function (e) {
    var t = new Date();
    t.setTime(t.getTime() + -1 * n.day), document.cookie = e + "=; expires=" + t.toUTCString() + "; path=/";
  }, n.day = 864e5, n;
}();

exports.Cookie = Cookie;